import { useCallback, useState } from "react";
import moment from "moment";
import { FiltroRelatorioReservas } from "core/features/relatorios/typings/index";
import { ReservaFiltroTipoData } from "features/reservas/typings";

export const defaultFiltroRelatorioReservas: FiltroRelatorioReservas = {
  search: "",
  unidadeId: "",
  pessoaId: "",
  tipoData: ReservaFiltroTipoData.DataReserva,
  dataFim: moment().format("YYYY-MM-DD"),
  dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
};

function useFiltroRelatorioReservas() {
  const [filtro, setFiltro] = useState<FiltroRelatorioReservas>(
    defaultFiltroRelatorioReservas
  );

  const onChangeFiltro = useCallback(
    (newValues: Partial<FiltroRelatorioReservas>) => {
      setFiltro((prev: any) => ({ ...prev, ...newValues }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroRelatorioReservas);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroRelatorioReservas;
